// Sign-in, sign-up, and verification pages return the user to `?next=`. Only paths
// on this site are followed, so a crafted link cannot send users to another website,
// and never the sign-in pages themselves.
const AUTH_PATHS = ["/login", "/register", "/forgot-password"];

function isAuthPath(path) {
  const pathname = path.split(/[?#]/)[0];
  return AUTH_PATHS.includes(pathname);
}

export function safeNextPath(value, fallback = "/") {
  const path = String(value || "");
  if (!path.startsWith("/") || path.startsWith("//") || path.startsWith("/\\")) return fallback;
  return isAuthPath(path) ? fallback : path;
}

function withNext(path, next) {
  const target = safeNextPath(next, "/");
  return target === "/" ? path : `${path}?next=${encodeURIComponent(target)}`;
}

export const loginPath = (next) => withNext("/login", next);
export const registerPath = (next) => withNext("/register", next);
export const forgotPasswordPath = (next) => withNext("/forgot-password", next);
export const verifyAccountPath = (next) => withNext("/verify-account", next);

export function currentPath(location = window.location) {
  return `${location.pathname}${location.search}`;
}

// Payments need a verified email address or mobile number (see transactions.mixins).
export function accountIsVerified(me) {
  return Boolean(me?.email_verified || me?.phone_verified);
}
